export default __webpack_public_path__ + "img/datelier-blue.dc6170fd.jpg";